import { useState } from 'react';
import { Box, Button } from '@mui/material';
import { useSelectedRows } from '../tabla/SelectedRowsContext';
import '../../estilo/App.css';
import ConfirmEnviarContModal from '../modales/EnviarContestModal';
import ProgressBarModal from '../modales/ProgressBar';
import axiosInstancePromise from '../../general/axiosConfig';

const BtnEnviarContestacion = ({table, funcSenal}) => {
  const { selectedRows, setSelectedRows} = useSelectedRows();
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openModalBar, setOpenModalBar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const handleContestar = (user) => {
    setOpenConfirmModal(true);
  };
  
  const handleConfirmContestar = async (customEmailData = null) => {
    setOpenConfirmModal(false);
    setOpenModalBar(true);

    try {
      const facturas = selectedRows
        .map(row => row['factura'])
        .filter(Boolean); // Elimina nulos/undefined/"" automáticamente

      if (facturas.length === 0) {
        alert("Ninguna de las facturas seleccionadas es válida para enviar la contestación.");
        setOpenModalBar(false);
        return;
      }

      const axiosInstance = await axiosInstancePromise;

      const payload = {
        facturas,
        ...(customEmailData && { correo_custom: customEmailData })
      };

      const response = await axiosInstance.post(`/enviar-contestacion`, payload, {
        validateStatus: status => status === 202 || (status >= 200 && status < 300)
      });

      // Manejo flexible de job_ids
      const rawJobIds = response.data.job_ids;
      const taskIds = Array.isArray(rawJobIds)
        ? rawJobIds
        : String(rawJobIds).split(',').map(id => id.trim()).filter(Boolean);

      if (taskIds.length === 0) {
        throw new Error("No se recibieron tareas para verificar.");
      }

      const checkInterval = setInterval(async () => {
        try {
          const statusRes = await axiosInstance.post('/task-status', {
            task_id: taskIds
          });

          const statusMap = statusRes.data;
          const allDone = taskIds.every(id => {
            const state = statusMap[id]?.status;
            return state === 'SUCCESS' || state === 'FAILURE';
          });

          if (allDone) {
            clearInterval(checkInterval);
            setOpenModalBar(false);

            const anyFailures = taskIds.some(id => statusMap[id]?.status === 'FAILURE');

            setSnackbarMessage(
              anyFailures
                ? "Una o más tareas fallaron al enviar las contestaciones."
                : "¡Las contestaciones han sido enviadas con éxito!"
            );
            setSnackbarSeverity(anyFailures ? 'error' : 'success');
            funcSenal();
          }
        } catch (e) {
          clearInterval(checkInterval);
          console.error("Error al verificar estado de tareas:", e);
          setOpenModalBar(false);
          setSnackbarMessage("Error al verificar el estado de la tarea.");
          setSnackbarSeverity("error");
        }
      }, 3000);

    } catch (error) {
      console.error("Error en la solicitud:", error);
      setOpenModalBar(false);

      if (error.response) {
        const backendMessage = error.response.data?.Mensaje || "Hubo un problema al procesar la solicitud.";
        setSnackbarMessage(backendMessage);
      } else {
        setSnackbarMessage("Hubo un error inesperado al enviar las contestaciones.");
      }
      setSnackbarSeverity('error');
    }
    setSelectedRows([]);
  };
  return (
    <Box>
      <Box>
        <Button sx={{mt:2}} variant="outlined" disabled={selectedRows.length === 0} onClick={handleContestar}
          >Enviar Respuesta a glosa
        </Button>
      </Box>
      <ConfirmEnviarContModal
        open={openConfirmModal}
        handleClose={() => setOpenConfirmModal(false)}
        onConfirm={handleConfirmContestar} 
      />
      <ProgressBarModal open={openModalBar} duration={(selectedRows.length * 1000) + 3000}
        message={'Enviando contestaciones...'}
        snackbarMessage={snackbarMessage} 
        severity={snackbarSeverity}
        onClose={() => setOpenModalBar(false)}/>
    </Box>   
  );
};

export default BtnEnviarContestacion;
